import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import CurrentAccountEditForm from './CurrentAccountEditForm';
import Header from 'components/ui/general/Header';
import LoadingCard from 'components/loading/LoadingCard';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { fetchCurrentAccount } from 'store/actions/accounts/fetchCurrentAccount';
import { updateCurrentAccount } from 'store/actions/accounts/updateCurrentAccount';
import utils from 'helpers/utils';

class CurrentAccountEditContainer extends Component {
    componentDidMount() {
        this.props.fetch();
    }

    handleSubmitForm = (values) => {
        const {
            resource,
            dispatchForm,
            history,
        } = this.props;

        return new Promise((resolve) => {
            dispatchForm({
                onError: () => {
                    resolve();
                },
                onSuccess: () => {
                    resolve(history.push(`/${ resource }`));
                },
                values: values,
            });
        });
    };

    render() {
        const {
            data,
            loading,
            resource,
            translate,
        } = this.props;

        if (loading && utils.isEmpty(data)) {
            return <LoadingCard />;
        }

        if (utils.isEmpty(data)) {
            return null;
        }

        const breadcrumbs = [
            {
                label: data.name,
                link: `/${ resource }`,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.accounts.actions.edit') } />
                </Header>

                <Card>
                    <CardText>
                        <CurrentAccountEditForm
                            data={ data }
                            form='current_account_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                            resource={ resource }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

CurrentAccountEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    fetch: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    history: PropTypes.object.isRequired,
    resource: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const { resource } = props;

    return {
        loading: state[resource].loading,
        data: state[resource].data,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateCurrentAccount(values));
        },
        fetch: () => {
            dispatch(fetchCurrentAccount());
        },
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
);

export default enhance(CurrentAccountEditContainer);



// WEBPACK FOOTER //
// ./src/pages/accounts/current-account/edit/CurrentAccountEditContainer.js